module.exports = __webpack_public_path__ + "static/img/sence-3-map.55cd7b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sence-3-map.png
// module id = Xkm2
// module chunks = 1